import React from 'react';

// The BattleBooks shield spinner (battlebooks src/components/ShieldSpinner.tsx), ported: a brand segment marches
// around the shield outline while loading; 'done' shows a check, 'error' an exclamation. One source for the web —
// the React component for the UI and shieldSpinnerSvg() for places that need an SVG string (the photo skeleton
// that sits in the note editor as an <img>).

const SHIELD = 'M12 2.5 L19.5 5.2 V11 C19.5 15.8 16 19.5 12 21.5 C8 19.5 4.5 15.8 4.5 11 V5.2 Z';
const CHECK = 'M8.4 12.2 L10.9 14.7 L15.6 9.4';
const ACCENT = '#FB5446';

export default function ShieldSpinner({ size = 22, state = 'loading', label, tone, className, style }) {
  const width = Math.round((size * 20) / 22);
  const colour = tone || (state === 'error' ? 'var(--c-danger)' : 'var(--c-accent)');
  const aria = label ?? (state === 'done' ? 'Done' : state === 'error' ? 'Failed' : 'Loading');
  const line = { fill: 'none', strokeWidth: 2.2, strokeLinecap: 'round', strokeLinejoin: 'round' };
  const mark = { ...line, strokeWidth: 2.4, stroke: colour };
  return (
    <span role="status" aria-label={aria} className={className} style={{ display: 'inline-flex', width, height: size, flex: 'none', ...style }}>
      <svg viewBox="0 0 24 24" width={width} height={size} aria-hidden="true">
        <path d={SHIELD} style={{ ...line, stroke: colour, opacity: state === 'loading' ? 0.28 : 1 }} />
        {state === 'loading' ? (
          <path d={SHIELD} style={{ ...line, stroke: colour }} strokeDasharray="14 62">
            <animate attributeName="stroke-dashoffset" from="0" to="-76" dur="1.05s" repeatCount="indefinite" />
          </path>
        ) : null}
        {state === 'done' ? <path d={CHECK} style={mark} /> : null}
        {state === 'error' ? <><path d="M12 8 L12 13" style={mark} /><path d="M12 15.7 L12 15.8" style={mark} /></> : null}
      </svg>
    </span>
  );
}

/** The loading shield as SVG markup for inside another <svg>: the shield itself `size` px tall, centred on (cx, cy). */
export function shieldSpinnerSvg({ size, cx = 0, cy = 0, colour = ACCENT }) {
  const s = size / 19;                // the outline spans y 2.5–21.5 of the 24 box
  return `<g transform="translate(${cx - 12 * s} ${cy - 12 * s}) scale(${s})" fill="none" stroke="${colour}" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
<path d="${SHIELD}" opacity=".28"/>
<path d="${SHIELD}" stroke-dasharray="14 62"><animate attributeName="stroke-dashoffset" from="0" to="-76" dur="1.05s" repeatCount="indefinite"/></path></g>`;
}
